import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './custom.scss'
import { createBrowserHistory } from 'history'
import { Auth0Provider } from '@auth0/auth0-react'
import { audience } from 'api/helpers'
import { BrowserRouter, useNavigate } from 'react-router-dom'
import EnhancedErrorBoundary from './shared/enhanced-error-boundary'

// Handle Vite preload errors that occur when assets from a previous deployment
// are no longer available. This typically happens when a user has the app open
// during a new deployment and tries to navigate to a lazily-loaded route.
// Uses the same cooldown guard as the inline script in index.html to prevent loops.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  const RELOAD_KEY = 'app_reload_attempt'
  const last = sessionStorage.getItem(RELOAD_KEY)
  if (last && (Date.now() - parseInt(last, 10)) < 10000) return
  sessionStorage.setItem(RELOAD_KEY, Date.now().toString())
  window.location.reload()
})

export const history = createBrowserHistory()

const Auth0ProviderWithRedirectCallback = ({ children, ...props }) => {
  const navigate = useNavigate()

  const onRedirectCallback = (appState) => {
    navigate((appState && appState.targetUrl) || window.location.pathname)
  }

  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  )
}

// Self-XSS warning for developer console
if (import.meta.env.PROD) {
  console.log(
    '%cStop!',
    'color: red; font-size: 50px; font-weight: bold;'
  )
  console.log(
    '%cThis is a browser feature intended for developers. If someone told you to copy-paste something here, it is likely a scam that could compromise your account and your organization\'s data.',
    'font-size: 18px;'
  )
  console.log(
    '%cSee https://en.wikipedia.org/wiki/Self-XSS for more information.',
    'font-size: 18px;'
  )
}

ReactDOM.render(
  <BrowserRouter>
    <EnhancedErrorBoundary>
      <Auth0ProviderWithRedirectCallback
        domain={import.meta.env.VITE_AUTH0_DOMAIN}
        clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
        redirectUri={window.location.origin}
        audience={audience}
        {...(import.meta.env.DEV && {
          cacheLocation: 'localstorage',
          useRefreshTokens: true,
        })}
      >
        <App />
      </Auth0ProviderWithRedirectCallback>
    </EnhancedErrorBoundary>
  </BrowserRouter>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals()
